function ErrorMessage({ message }) {
  return <span className="error_msg">{message}</span>;
}

export default ErrorMessage;
